export const hasDatePicker = (schema: any) => {
    const childSchema = schema.children?.children
    if (childSchema) {
        const childSchemaKeys = Object.keys(childSchema)
        return !!childSchemaKeys.find((key) => {
            return (
                childSchema[key]?.type === 'datetime' ||
                childSchema[key]?.type === 'time'
            )
        })
    }
    return false
}
